import React, { useEffect } from 'react';
import Portal from './Portal';

const TaskPopover = ({ task, isVisible, onClose, onEdit, onDelete }) => {
  console.log(task);
  
  // Helper function to convert status integer to string
  const getStatusString = (status) => {
    switch (status) {
      case 1: return 'Open';
      case 2: return 'In Progress';
      case 4: return 'Completed';
      default: return 'Unknown';
    }
  };
  
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isVisible) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'auto'; 
    };
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  const getStatusColor = (status) => {
    console.log(status)
    switch (status) {
      case 'Completed': return '#2563eb';
      case 'In Progress': return '#d97706';
      case 'Open': return '#059669';
      default: return 'var(--primary-color)';
    }
  };

  const handleActionClick = (e, action) => {
    e.stopPropagation();
    e.preventDefault();
    console.log(`TaskPopover: ${action} button clicked for task:`, task);
    
    // Handle different task data structures consistently
    const taskData = task.tasks && task.tasks.length > 0 ? task.tasks[0] : task;
    console.log('TaskPopover: Using task data for action:', taskData);
    
    if (action === 'edit' && onEdit) {
      console.log('TaskPopover: Calling onEdit with task:', taskData);
      onEdit(taskData);
      onClose(); // Close the popover after starting edit
    } else if (action === 'delete' && onDelete) {
      console.log('TaskPopover: Showing delete confirmation for task:', taskData);
      // Show confirmation dialog before deleting
      if (window.confirm('Are you sure you want to delete this task?')) {
        console.log('TaskPopover: User confirmed delete, calling onDelete with:', taskData);
        onDelete(taskData);
        onClose(); // Close the popover after delete
      } else {
        console.log('TaskPopover: User cancelled delete');
      }
    } else {
      console.warn(`TaskPopover: No handler for action "${action}" or handler not provided`);
    }
  };

  // Prevent event bubbling when clicking inside the popover
  const handlePopoverClick = (e) => {
    e.stopPropagation();
  };

  // Handle different task data structures
  const taskData = task.tasks && task.tasks.length > 0 ? task.tasks[0] : task;

  const popoverContent = (
    <>
      <div className="task-popover-backdrop" onClick={onClose} />
      <div className={`task-popover-sidebar ${isVisible ? 'slide-in' : ''}`} onClick={handlePopoverClick}>
        <div className="task-popover-sidebar-content">
          <button
            className="close-popover-sidebar"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            aria-label="Close task details"
          >
            <i className="fas fa-times"></i>
          </button>

          <div className="task-popover-header">
            <h3 className='pop-header'>{taskData.name || taskData.title}</h3>
            <span
              className="task-status-badge"
              style={{ backgroundColor: taskData.status === 1 ? '#10b981' : taskData.status === 2 ? '#f59e0b': '#3b82f6'}}
            >
              {getStatusString(taskData.status)}
            </span>
          </div>

          <div className="task-popover-body">
            <div className="task-popover-section">
              <i className="fas fa-clock"></i>
              <span className='due-task-pop'>Due Date: {task.due_date || taskData.due_date}</span>
            </div>

            {taskData.project_name && (
              <div className="task-popover-section">
                {/* <i className="fas fa-project-diagram"></i> */}
                <span className="task-project">
                  Project: {taskData.project_name}
                </span>
              </div>
            )}

            {taskData.members && taskData.members.length > 0 && (
              <div className="task-popover-section">
                {/* <i className="fas fa-user"></i> */}
                <span className="task-owner">
                  Assignees: {taskData.members.map((member, index) => (
                    <span key={index}>
                      {member}
                      {index !== taskData.members.length - 1 && ', '}
                    </span>
                  ))}
                </span>
              </div>
            )}

            {taskData.description && (
              <div className="task-popover-description">
                <h4 className='desc-pop'>Description</h4>
                <p>{taskData.description}</p>
              </div>
            )}
          </div>

          <div className="task-popover-footer">
            <button
              className="task-action-btn edit"
              onClick={(e) => handleActionClick(e, 'edit')}
            >
              <i className="fas fa-edit"></i> Edit
            </button>
            <button
              className="task-action-btn delete"
              onClick={(e) => handleActionClick(e, 'delete')}
            >
              <i className="fas fa-trash-alt"></i> Delete
            </button>
          </div>
        </div>
      </div>
    </>
  );

  return <Portal>{popoverContent}</Portal>;
};

export default TaskPopover; 